import actionTypes from './actionTypes';
import GraphSource from '../../sources/graph';
import GraphActions from '../graph';

import { addNotification } from './notification';

export const addNote = (note, flowId) => ({
    type: actionTypes.NOTE_ADD,
    payload: { note, flowId },
});

export const updateNote = note => ({
    type: actionTypes.NOTE_UPDATE,
    payload: note,
});

export const setAllNotes = (items, flowId) => ({
    type: actionTypes.NOTE_SET_ALL,
    payload: { items, flowId },
});

export const editNote = id => ({
    type: actionTypes.NOTE_EDIT,
    payload: { id },
});

export const toggleNoteVisibility = id => ({
    type: actionTypes.NOTE_TOGGLE_VISIBILITY,
    payload: { id },
});

export const saveNote = (
    payload,
    flowId,
    editingToken,
    tenantId,
    authenticationToken,
    isNew = false,
) => async (dispatch) => {

    payload.userContentDateModified = new Date().toUTCString();

    try {
        const note = await GraphSource.saveMapElement(
            payload,
            flowId,
            editingToken,
            'map',
            tenantId,
            authenticationToken,
        );

        if (isNew) {

            // When a new mapelement is created the entire canvas
            // contents need to be fetched again so everything can re-render
            GraphActions.get(flowId, tenantId, authenticationToken);
            dispatch(
                addNote(note, flowId),
            );
        } else {
            dispatch(
                updateNote(note),
            );
        }

    } catch (error) {
        dispatch(addNotification({
            type: 'error',
            message: error.message,
            isPersistent: true,
        }));
    }
};

export const fetchNotes = (
    flowId,
    editingToken,
    tenantId,
    authenticationToken,
) => async (dispatch) => {

    try {
        const elements = await GraphSource.getMapElements(
            flowId,
            editingToken,
            tenantId,
            authenticationToken,
        );

        const notes = elements.filter(element => element.elementType === 'note');

        dispatch(
            setAllNotes(notes, flowId),
        );

    } catch (error) {
        dispatch(addNotification({
            type: 'error',
            message: error.message,
            isPersistent: true,
        }));
    }
};
